import {env} from "../../../../../res/config/env";
import SolrProduct from "../../../../logic/search/solrProduct";
import HttpClient from "../../../http/HttpClient";
import Platform from "../../../../logic/platform/platform";

const processResponse = (res) => {
    const solrResponse = res.data.response;
    const products = solrResponse.docs.map(SolrProduct.formatProduct);
    const count = solrResponse.numFound;
    const start = solrResponse.start;
    return {
        products,
        count,
        start
    }
}

const buildRequestUrl = (params) => {

    const url = env.API_SOLR_URL;
    const select = "select?q="

    const paramList = params.query.reduce((l,p) => {
        const encapsulated = "(" + p + ")"
        if(l === "") return encapsulated;
        else return l + "AND" + encapsulated;
    }, "")

    const start = params.start ? ("&start=" + params.start) : ""
    const pageSize = params.pageSize ? ("&rows=" + params.pageSize) : "";

    const passedSort = params.sort.reduce((l,p) => l + p + ", ", "");

    const sort = "&sort="+passedSort+"LYSales desc,M_Product_ID desc&sortMissingLast=true"

    const filterList = params.filterQuery.reduce((l,p) => {
        return l + "&fq=" + p;
    }, "");

    const preFormat = url + select + paramList + filterList + start + pageSize + sort;
    if(Platform.isIos()) {
        return preFormat;
    } else {
        return preFormat.replaceAll(" ", "%20");
    }

}

const formatValue = (value) => {
    if(Platform.isIos()) {
        return value;
    }


    return value.replace("&", "%26");
}

const splitArrayIntoChunks = (arr, chunkSize = 100) => {
    const result = [];
    for (let i = 0; i < arr.length; i += chunkSize) {
        result.push(arr.slice(i, i + chunkSize));
    }
    return result;
}

const solrProductRequest = () => {

    const builder = {};

    const params = {};
    params.query = [];
    params.filterQuery = [];
    params.sort = [];

    builder.addQueryItem = (q) => {
        params.query.push(q);
        return builder;
    }

    builder.addFilterQueryItem = (q) => {
        params.filterQuery.push(q);
        return builder;
    }

    builder.queryMatching = (field, value) => {
        builder.addQueryItem(field + ":" + value);
        return builder;
    }

    builder.priceListExclusion = (priceListID) => {
        if(!priceListID || priceListID <= 0) {
            // builder.addFilterQueryItem("-exclusions:[* TO *]");
        } else {
            builder.addFilterQueryItem("-exclusions:" + priceListID);
        }
    }

    builder.sortBy = (sortingCriteria) => {
        params.sort.push(sortingCriteria);
        return builder;
    }

    const getQueryParamForList = (fieldsAndValues) => {
        return fieldsAndValues.reduce((qi, {field, value, score}) => {
            const item = `(${field}:"${formatValue(value)}")${score != null ? "^" + score + " " : ""}`;
            if(qi === "") return item;
            else return qi + "OR" + item;
        }, "")
    }


    // TODO replace with some kind of condition builder
    builder.queryMatchingOrList = (fieldsAndValues) => {
        builder.addQueryItem(getQueryParamForList(fieldsAndValues));
        return builder;
    }

    builder.productIDs = (pids) => {
        params.productIDs = pids;
        return builder;
    }

    builder.pageSize = (size) => {
        params.pageSize = size;
        return builder;
    }

    builder.start = (start) => {
        params.start = start;
        return builder;
    }

    const getProducts = async (params) => {
        const url = buildRequestUrl(params);
        const res = await HttpClient.client.get(url);
        return processResponse(res);
    }

    builder.sendRequest = async () => {
        if(!params.productIDs || params.productIDs.length < 1) {
            return getProducts(params);
        } else {
            const productIDGroups = splitArrayIntoChunks(params.productIDs);
            const promiseOfProducts = [];
            productIDGroups.forEach((group, gn) => {
                const pidAndField = group.map((id,i) => ({field: "M_Product_ID", value: String(id), score: (i + (gn * 100))}));
                const param = getQueryParamForList(pidAndField);
                const query = [...params.query, param];
                const groupParas = {...params, query};
                promiseOfProducts.push(getProducts(groupParas));
            });
            const allPromise = await Promise.all(promiseOfProducts);
            return allPromise.reduce((a, cv) => {
                const updated = {};
                updated.products = [...cv.products, ...a.products];
                updated.count = cv.count + a.count;
                if(cv.start) {
                    updated.start = Math.min(cv.start, a.end);
                } else {
                    updated.start = a.start;
                }
                return updated;
            }, { products: [], count: 0, start: null })
        }
    }

    return builder;
}

export default solrProductRequest;
